import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as contactUsService from "../../services/contact-us.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder} from "rsuite";

const ViewContactUs = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: "Contact Us",
      url: "/admin/contact-us/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    contactUsService
      .Details(params.id)
      .then((response) => {
        if (response.success) {
           setShowDefault(response.data || {});
        }
      })
      .catch((error) => {
        console.error("View error:", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  VIEW INQUIRY
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault?.name || "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            {showdefault?.email || "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_subject")}</th>
                          <td>
                            {showdefault?.subject || "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_message")}</th>
                          <td>
                            {showdefault?.message || "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_inquiry_date")}</th>
                          <td>
                            {showdefault?.createdAt
                              ? formateDateWithMonth(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
               <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/contact-us/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewContactUs;
